/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type MapType = typeof MapType[keyof typeof MapType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MapType = {
  GL: 'GL',
  AC: 'AC',
} as const;
